import React from 'react'

import clsx from 'clsx'

import Avatars from 'components/Avatars'
import Grid from 'components/Grid'
import Icon from 'components/Icon'
import InfoCircleTooltip from 'components/InfoCircleTooltip'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import { thousandSeparator } from 'helpers/formatters'
import { handleScrollTo } from 'screens/compare/components/NavigationList/helpers'

import classes from './ProsAndCons.module.scss'

const MAX_REVIEWERS = 3

const addAvatarsFromSnippets = (reviewers, snippets) => {
  if (!snippets) return

  for (let i = 0; i < snippets.length; i++) {
    const avatar = snippets[i]?.avatar
    if (avatar && reviewers.length < MAX_REVIEWERS) {
      reviewers.push(avatar)
    }
    if (reviewers.length >= MAX_REVIEWERS) break
  }
}
const getAvatarsFromSnippets = (pros, cons) => {
  const reviewers = []
  for (let i = 0; i < pros.length && reviewers.length < MAX_REVIEWERS; i++) {
    addAvatarsFromSnippets(reviewers, pros[i].snippets)
  }
  if (cons && reviewers.length < MAX_REVIEWERS) {
    for (let i = 0; i < cons.length && reviewers.length < MAX_REVIEWERS; i++) {
      addAvatarsFromSnippets(reviewers, cons[i].snippets)
    }
  }
  // Fill remaining slots with null avatars
  while (reviewers.length < MAX_REVIEWERS) {
    reviewers.push(null)
  }
  return reviewers.reverse()
}

const ProCon = ({ name, isPro = false }) => (
  <div className={classes.itemContainer}>
    <Icon
      size={12}
      className={clsx(classes[isPro ? 'iconPros' : 'iconCons'], classes.icon)}
      icon={isPro ? 'caret-circle-up' : 'caret-circle-down'}
    />
    <Typography variant="tight-xs">{name}</Typography>
  </div>
)

const ProsAndCons = ({ pros, cons, reviewsTotal, shouldShowAvatar }) => {
  const reviewerUrls = getAvatarsFromSnippets(pros, cons)
  const { sendEvent } = useEventContext()
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} className={classes.titleContainer}>
        <InfoCircleTooltip
          className={classes.titleAndIcon}
          enterTouchDelay={100}
          leaveTouchDelay={3000}
          label={<Typography variant="title-8">Pros & Cons</Typography>}
          title={`To determine these pros and cons insights, we analyzed responses from ${thousandSeparator(
            reviewsTotal
          )} verified reviews`}
        />

        {shouldShowAvatar && reviewerUrls.filter(item => item !== null).length !== 0 && (
          <Avatars imageSize={24} imagesUrl={reviewerUrls} className={classes.avatars} />
        )}
      </Grid>
      <Grid item xs={12} className={classes.section}>
        {pros.map((pro, index) => (
          <ProCon key={`pro-${index}`} name={pro.title} isPro />
        ))}
      </Grid>
      <Grid item xs={12} className={classes.section}>
        {cons.map((con, index) => (
          <ProCon key={`con-${index}`} name={con.title} />
        ))}
      </Grid>
      <Grid item xs={12} className={classes.section}>
        <Link
          variant="tight-xxs"
          onClick={() => {
            sendEvent({
              name: 'engagement_product_click',
              engagementComponent: 'product_overview',
              engagementDetails: 'textlink_see-pros-and-cons-details',
              engagementDestination: 'product_pros-and-cons',
            })
            handleScrollTo('reviews', 100)
          }}
        >
          See all pros and cons
        </Link>
      </Grid>
    </Grid>
  )
}
export default ProsAndCons
